import { isString } from 'lodash-es';
import z from 'zod';
const requiredKey = 'myApp.error.required';
export const AppSchemaSpec = {
  name: {
    maxLength: {
      value: 26,
      message: 'myApp.error.maxLength'
    }
  },
  description: {
    maxLength: {
      value: 50,
      message: 'myApp.error.maxLength'
    }
  },
  file: {
    maxSize: {
      value: 16 * 1024 * 1024
    }
  },
  icon: {
    maxSize: {
      value: 1 * 1024 * 1024
    }
  }
};
export const AppSchema = z.object({
  name: z.string({
    required_error: requiredKey
  }).min(1, {
    message: requiredKey
  }).max(AppSchemaSpec.name.maxLength.value, AppSchemaSpec.name.maxLength.message),
  description: z.string({
    required_error: requiredKey
  }).min(1, {
    message: requiredKey
  }).max(AppSchemaSpec.description.maxLength.value, AppSchemaSpec.description.maxLength.message),
  type: z.number(),
  url: z.string().optional(),
  icon: z.custom<File | string>(v => v instanceof File || isString(v)).optional(),
  file: z.custom<File | string>(v => v instanceof File || isString(v))
});
export type AppSchemaType = z.infer<typeof AppSchema>;